import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UpgradeSuccess = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timeout = setTimeout(() => {
      navigate('/dashboard');
    }, 10000); // 10 seconds

    return () => clearTimeout(timeout);
  }, [navigate]);

  return (
    <div className="flex items-center justify-center h-screen bg-white text-center">
      <div className="max-w-xl px-6 py-10 rounded-lg shadow-md bg-gray-50">
        <h1 className="text-3xl font-bold text-primary-purple mb-4">🎉 Upgrade Successful!</h1>
        <p className="text-lg text-secondary-navy mb-4">
          Your Pro plan is now active! You now have full access to all features, scenarios, and reports.
        </p>
        <p className="text-sm text-gray-600 mb-6">
          You’ll be redirected to your dashboard in a few seconds.
        </p>
        <button
          onClick={() => navigate('/dashboard')}
          className="px-6 py-3 text-white bg-purple-800 font-semibold rounded-lg hover:bg-primary-green transition"
        >
          Go to Dashboard Now
        </button>
      </div>
    </div>
  );
};

export default UpgradeSuccess;
